import { FeatureFlags } from 'utils/featureFlags';
import { useFeatureFlagStatus } from './useFeatureFlag';

export interface CrmPricingEmbedFlagStatus {
  enabled: boolean;
  isLoading: boolean;
}

export function useCrmPricingEmbedFlagStatus(): CrmPricingEmbedFlagStatus {
  const { flags, isLoading } = useFeatureFlagStatus([FeatureFlags.crmPricingEmbed]);
  return { enabled: flags[FeatureFlags.crmPricingEmbed] === true, isLoading };
}
